module.exports = __webpack_public_path__ + "img/bg-desktop.b48aed95.png";